import React, { useState } from "react";
import ReactSwitch from "react-switch";

const Switch = ({ onToggal, name = "Sound", defaultValue = false }) => {
  const [checked, setChecked] = useState(defaultValue);

  const handleChange = (nextChecked) => {
    setChecked(nextChecked);
    onToggal && onToggal(nextChecked);
  };

  return (
    <div className="settings-switch-row flex items-center justify-between w-full  py-2">
      <span className="settings-switch-label text-lg font-semibold text-black">{name}</span>
      <ReactSwitch
        checked={checked}
        onChange={handleChange}
        onColor="#A678DF"
        offColor="#ccc"
        handleDiameter={22}
        uncheckedIcon={false}
        checkedIcon={false}
        height={32}
        width={50}
      />
    </div>
  );
};

export default Switch;
